import { Response } from '../../utils/interfaces/response';
import { ProgramaDTO } from '../../utils/models';
import http from '../http/http';

export class ProgramService {
  getProgramSufixByLevel(levelID: string) {
    return http.get<Response<ProgramaDTO[]>>(`/Programa/Sufijos/${levelID}`);
  }
}
